import { useEffect, useState } from 'react'
import ModalComponent from 'components/common/ModalComponent'
import { showAlert } from 'services/alerts.service'
import { makeRequest } from 'services/request.service'

const PickingDataEditModal = ({ isOpen, handleSave, handleClose, selectedPickingData, isBulk, bulkCount, farmId }) => {
  const [farmingBlocks, setFarmingBlocks] = useState([])
  const [workers, setWorkers] = useState([])

  useEffect(() => {
    if (!isOpen || !farmId) return
    const headers = { Authorization: `Bearer ${localStorage.getItem('secret')}` }

    makeRequest({ method: 'GET', url: `/management/farming-blocks/${farmId}`, headers })
      .then(r => setFarmingBlocks(r.data ?? []))
      .catch(err => console.error('Failed to load farming blocks', err))

    makeRequest({ method: 'GET', url: `/management/workers-management/${farmId}/all`, headers })
      .then(r => setWorkers(r.data ?? []))
      .catch(err => console.error('Failed to load workers', err))
  }, [isOpen, farmId])

  const getInitialData = () => {
    if (isBulk) return { farmingBlockId: '', workerId: '', totalUnits: '' }
    return {
      farmingBlockId: selectedPickingData?.farmingBlockId ?? '',
      workerId: selectedPickingData?.workerId ?? '',
      totalUnits: selectedPickingData?.totalUnits ?? ''
    }
  }

  const handleSaveClick = (formData) => {
    if (!formData) {
      showAlert({ text: 'Form data is missing', icon: 'error' })
      return
    }

    const payload = {}
    if (formData.farmingBlockId !== '' && formData.farmingBlockId != null) payload.farmingBlockId = Number(formData.farmingBlockId)
    if (formData.workerId !== '' && formData.workerId != null) payload.workerId = Number(formData.workerId)
    if (formData.totalUnits !== '' && formData.totalUnits != null) {
      const units = parseInt(formData.totalUnits)
      if (isNaN(units) || units < 0) {
        showAlert({ text: 'Total units must be a positive number', icon: 'warning' })
        return
      }
      payload.totalUnits = units
    }

    if (Object.keys(payload).length === 0) {
      showAlert({ text: 'No changes to save', icon: 'info' })
      return
    }

    handleSave(payload)
  }

  const title = isBulk
    ? `Edit ${bulkCount} record${bulkCount !== 1 ? 's' : ''}`
    : 'Edit Picking Data'

  return (
    <ModalComponent
      title={title}
      isOpen={isOpen}
      onClose={handleClose}
      onSave={handleSaveClick}
      initialData={getInitialData()}
      key={isOpen ? 'open' : 'closed'}
    >
      {({ formData, handleChange }) => (
        <form className='space-y-4 w-72' autoComplete='off'>
          {isBulk && (
            <p className='text-sm text-gray-500'>Only filled fields will be updated across all selected records.</p>
          )}

          <label className='block text-sm font-medium'>
            Farming Block
            <select
              name='farmingBlockId'
              value={formData?.farmingBlockId ?? ''}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            >
              <option value=''>— Keep current —</option>
              {farmingBlocks.map(b => (
                <option key={b.farmingBlockId} value={b.farmingBlockId}>{b.name}</option>
              ))}
            </select>
          </label>

          <label className='block text-sm font-medium'>
            Worker
            <select
              name='workerId'
              value={formData?.workerId ?? ''}
              onChange={handleChange}
              className='w-full mt-1 p-2 border rounded'
            >
              <option value=''>— Keep current —</option>
              {workers.map(w => (
                <option key={w.workerId} value={w.workerId}>
                  {w.firstName} {w.lastName}
                </option>
              ))}
            </select>
          </label>

          <label className='block text-sm font-medium'>
            Total Units
            <input
              type='number'
              name='totalUnits'
              min={0}
              step={1}
              value={formData?.totalUnits ?? ''}
              onChange={handleChange}
              placeholder='Leave blank to keep current'
              className='w-full mt-1 p-2 border rounded'
            />
          </label>
        </form>
      )}
    </ModalComponent>
  )
}

export default PickingDataEditModal
